<template>
  <div class="home">
     <!-- 大赛进程 -->
      <div class="content">

        <div class="jianjie">
        </div>
        <div class="incheng">
        </div>
        <div class="pingjia">
        </div>
        <div class="funeng">
        </div>
        <div class="zhuban">
        </div>
        <div class="xieban">
        </div>
        <div class="celue">
        </div>
        <div class="xuzhi">
        </div>
        <div class="mianze">
        </div>
        <div style="display:flex;justify-content: space-around;">
        <!-- 点击报名 -->
        <div class="canjiabtns" @click="goPages()">点击报名</div>
        <!-- 点击排名 -->
        <!-- <div class="canjiabtns" @click="goPages('/newRanking')">点击排名</div> -->
      </div>
        <div class="lianxi">
        </div>
      </div>
  </div>
</template>

<script>
import nativeService from '../services/common/nativeService.js'
export default {
  data() {
    return {
    }
  },
  methods: {
    goPages() {
      let storedData = sessionStorage.getItem('goldCJToken');
      if (storedData) {
        nativeService.routerRedirect('/signUp', this)
      }else{
        nativeService.routerRedirect('/login', this)
      }

      // switch (url) {
      //   case '/signUp':
      //     nativeService.routerRedirect(url, this)
      //     break
      //   case '/newRanking':
      //     nativeService.routerRedirect(url, this)
      //     break
      // }
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'sass/gold/common.scss';
@import 'sass/gold/nextIndex.scss';
</style>
